import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SoftphoneWindowState {
  /** true = detached floating widget over all screens; false = docked into the page. */
  floating: boolean;
  /** Last floating position (px from viewport top/left). */
  x: number;
  y: number;
  setFloating: (v: boolean) => void;
  setPos: (x: number, y: number) => void;
}

export const useSoftphoneWindow = create<SoftphoneWindowState>()(
  persist(
    (set) => ({
      floating: false,
      // Default near the bottom-inline-end; clamped on first render.
      x: 24,
      y: 80,
      setFloating: (floating) => set({ floating }),
      setPos: (x, y) => set({ x, y }),
    }),
    { name: 'merkaziya-softphone-window' }
  )
);
